import { RootState } from "../hooks";

export const getMainSelector = (state: RootState) => state.main;
